import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { callGetApi } from '@/src/core/utils/api';
import { reactQueryConfigs } from '@/src/core/providers/ReactQueryProvider/configs';

type Result = number;
type Options = UseQueryOptions<Result, unknown, Result>;

export const fetchNumberOfUsers = async (): Promise<Result> => {
  try {
    const response: AxiosResponse<{
      status: string;
      data: Result;
      error: any;
    }> = await callGetApi('/profile/number-of-users');

    if (response.data.error) {
      throw new Error('your request encountered an error');
    }
    return response.data.data;
  } catch (e) {
    throw new Error('your request encountered an error');
  }
};

export const numberOfUsersQueryKey = ['number-of-users'];

export function useNumberOfUsers(options?: Options) {
  return useQuery(numberOfUsersQueryKey, fetchNumberOfUsers, {
    ...options,
    staleTime: options?.staleTime ?? reactQueryConfigs.staleTime,
    cacheTime: options?.cacheTime ?? reactQueryConfigs.cacheTime,
  });
}
